import lodash from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

import Card from '../../../../../1stlog-ui/src/components/Card'
import {
  FeedbackBadge,
  useField,
} from '../../../../../1stlog-ui/src/components/Field'
import IncoTerms2020 from '../../components/IncoTerms2020'
import OrderEntryCard, {
  IOrderEntryCardProps,
} from '../../components/OrderEntryCard'
import ImporterExporterHandler from './ImporterExporterHandler'

const CustomsTerms = (
  props: Omit<IOrderEntryCardProps, 'title' | 'children'>,
): React.ReactElement => {
  // const { isOld } = props

  const {
    input: { value: customsTerms, onChange: setCustomsTerms },
    meta,
  } = useField('customsTerms', {
    raw: true,
    validate: validateCustomsTerms,
    subscribeAll: true,
  })

  const [exporter, setExporter] = useState()
  const [importer, setImporter] = useState()

  return (
    <>
      <ImporterExporterHandler
        setExporter={setExporter}
        setImporter={setImporter}
        importer={importer}
        exporter={exporter}
        // isOld={isOld}
      />
      <OrderEntryCard
        {...props}
        title={i18n.t('order_incoterms', 'Frankatur - Incoterms 2020')}
      >
        {/* <FreightTermsTable value={customsTerms} onChange={setCustomsTerms} /> */}
        <FeedbackBadge meta={meta} />
        <IncoTerms2020
          value={customsTerms}
          onChange={setCustomsTerms}
          // importer={importer}
          // exporter={exporter}
        />
      </OrderEntryCard>
    </>
  )
}

export default CustomsTerms

function validateCustomsTerms(value: string): string | undefined {
  return value
    ? undefined
    : i18n.t('invalid_customs_terms', 'Bitte wählen Sie den Incoterm aus')
}
